import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { APIService } from '../apiservices/apiservices';


@Injectable()
export class FaqProvider {
  item;
  private header=APIService.getHeader();
  constructor(private http: HttpClient) {
    
  }
/**
 * Leitura da configuração
 */

  getFaq(){
    var me=this;
    return new Promise((resolve, reject) => {

    let url = "assets/data/faq.json?dummyDate="+ (new Date()).getTime();
      //url = "http://localhost:8101/assets/data/configapp/faq.json";
      
    this.http.get(url,{headers:me.header})
      .subscribe((result: any) => {
        var jsonData=result;
        if (jsonData.length!=0)
        {
          //me.item=jsonData;
          //var temp=[];
          //temp.push(jsonData)
          me.item=jsonData;
          resolve(me.item);
          
        }
        else{
          var errochamada={
            'status_ret':'NOK',
            'erro':'arquivo de faq'
          }
          me.item=errochamada;
          resolve(me.item);
        }
        
      },
      (error) => {
        var errochamada={
          'status_ret':'NOK',
          'erro':error.message
        }
        me.item=errochamada;
        reject(me.item);
        //resolve(me.login);
      });
    });

  }

  
}
